import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 flex items-center justify-center gap-3 shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-175">
      <div className="w-2.5 h-2.5 rounded-full bg-white animate-pulse shrink-0" data-id="element-176"></div>
      <p className="text-sm md:text-base font-semibold tracking-wide text-center" data-id="element-177">
        OFERTA DE LANZAMIENTO: Solo $6.99 USD por tiempo limitado
      </p>
      <div className="w-2.5 h-2.5 rounded-full bg-white animate-pulse shrink-0 hidden sm:block" data-id="element-178"></div>
    </div>;
}